/**
 * Single-host override for isolated environments (currently only preprod-dodo),
 * e.g. `https://fly-preprod-dodo.customer.io`.
 *
 * Such an environment serves every path from one host and has no region split,
 * so it fits none of the environment/region maps in the app. Giving it its own
 * `__CIO_ENV__` value would change every other `=== 'standalone'` branch at the
 * same time, so the host is overridden on its own instead.
 *
 * Deliberately NOT `VITE_API_URL`: that is already set for production,
 * standalone and the external-UI build, so keying off it would repoint those.
 *
 * When set it must win in every host resolver, not just some — an environment
 * that resolves half its traffic to itself and half to production is worse than
 * one that never worked.
 */
export function getApiHostOverride(): string {
  return (import.meta.env.VITE_API_HOST_OVERRIDE ?? '').trim();
}
